// extracted by mini-css-extract-plugin
export default {"imageSwitcher":"imageSwitcher-Xk_um4Ii"};